/**
 * RepeatSummary Component
 * 
 * Displays a summary of the meal being repeated and where it will be repeated to.
 * Shows selection count, meal titles, and any validation errors.
 */

import React from 'react';
import PropTypes from 'prop-types';

function RepeatSummary({
    titles,
    selections,
    validationErrors,
    hasOverlaps,
    overlapCount
}) {
    const selectionCount = selections.length;

    return (
        <div className="repeat-summary">
            <header>
                <h1>Repeat Meal</h1>
                <h3>{titles.join(' + ')}</h3>
            </header>

            {selectionCount > 0 && (
                <div className="selection-summary">
                    <p>
                        Will be repeated to <strong>{selectionCount}</strong> {selectionCount === 1 ? 'location' : 'locations'}
                    </p>
                    
                    {hasOverlaps && (
                        <div className="overlap-warning">
                            <i className="fa fa-warning" />
                            <span>
                                {overlapCount} {overlapCount === 1 ? 'conflict' : 'conflicts'} detected. 
                                You'll be asked how to resolve them.
                            </span>
                        </div>
                    )}
                </div>
            )}

            {validationErrors.length > 0 && (
                <div className="validation-errors">
                    {validationErrors.map((error, index) => (
                        <p key={index} className="error-msg">
                            <i className="fa fa-exclamation-circle" />
                            {error}
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
}

RepeatSummary.propTypes = {
    titles: PropTypes.arrayOf(PropTypes.string).isRequired,
    selections: PropTypes.arrayOf(PropTypes.shape({
        offset: PropTypes.number.isRequired,
        mealType: PropTypes.string.isRequired
    })).isRequired,
    validationErrors: PropTypes.arrayOf(PropTypes.string).isRequired,
    hasOverlaps: PropTypes.bool.isRequired,
    overlapCount: PropTypes.number.isRequired
};

export default RepeatSummary;